export const experienceData = [
    {
        id: 1,
        company: 'Veritas Technolabs - Ahmedabad',
        jobtitle: 'Mobile App Developer',
        startYear: '07/2022',
        endYear: '08/2022'
    },
    {
        id: 2,
        company: 'Maruti Suzuki - Gurgaon',
        jobtitle: 'Web Designer',
        startYear: '04/2022',
        endYear: '07/2022'
    },
    {
        id: 3,
        company: 'Mazaalo - Gurgaon',
        jobtitle: 'UI/UX Designer',
        startYear: '05/2021',
        endYear: '08/2021'
    },
    {
        id: 4,
        company: 'Nplus One IT Solution - Ahmedabad',
        jobtitle: 'Android Developer',
        startYear: '07/2019',
        endYear: '08/2020'
    },
]